export async function finishTrainingApi(postBody: any): Promise<any> {
  try {
    const response = await fetch(`/api/finishTraining`, {
      method: 'POST',
      body: JSON.stringify(postBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      console.log('Training finished successfully');
    } else {
      console.error('Failed to finish training');
    }
  } catch (error) {
    console.error('Error occurred while finishing training:', error);
  }
}
